import client from './client';

/**
 * Host weekly availability (scheduling slots).
 */

export const getMyAvailability = () => client.get('/api/availability');

export const setMyAvailability = (days) =>
  client.put('/api/availability', { days });

/**
 * Open slots for a host on a calendar date.
 * @param {string} hostEmail
 * @param {string} date - YYYY-MM-DD
 * @returns {Promise<{ data: { configured: boolean, slots: string[] } }>}
 */
export const getAvailabilitySlots = (hostEmail, date) =>
  client.get('/api/availability/slots', { params: { hostEmail, date } });
